import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'
import { getUserData } from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUserOld(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/user/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getBankAccountList() {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/BankAccount/GetList`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getBankList() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Bank/GetList`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addBankAccount(ctx, data) {
      const userData = getUserData()
      axios.defaults.headers.common["Authorization"] = "Bearer " + userData.token
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/BankAccount/AddOrUdpate`, data, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
